import SpaceInvaders from './spaceInvaders';
import Pacman from './pacman';
import Tetris from './tetris';
import Snake from './snake';
import Asteroids from './asteroids';
import BlueMax from './blueMax';
import Minesweeper from './minesweeper';
import Solitaire from './solitaire';
import { formatTime } from '../../lib/arcade/formatTime';

/**
 * Arcade game registry (C). Each game has matching backend GAME_RULES entries.
 * Optional best-time formatting lets timed games share the same cabinet.
 */
export const ARCADE_GAMES = [
    {
        key: 'spaceInvaders',
        title: 'Space Invaders',
        textKey: 'arcade.spaceInvaders',
        icon: '👾',
        component: SpaceInvaders,
    },
    {
        key: 'pacman',
        title: 'Pac-Man',
        textKey: 'arcade.pacman',
        icon: '🟡',
        component: Pacman,
    },
    {
        key: 'tetris',
        title: 'Tetris',
        textKey: 'arcade.tetris',
        icon: '🧱',
        component: Tetris,
    },
    {
        key: 'snake',
        title: 'Snake',
        textKey: 'arcade.snake',
        icon: '🐍',
        component: Snake,
    },
    {
        key: 'asteroids',
        title: 'Asteroids',
        textKey: 'arcade.asteroids',
        icon: '☄️',
        component: Asteroids,
    },
    {
        key: 'blueMax',
        title: 'Blue Max',
        textKey: 'arcade.blueMax',
        icon: '🛩️',
        component: BlueMax,
    },
    {
        key: 'minesweeper',
        title: 'Minesweeper',
        textKey: 'arcade.minesweeper',
        icon: '💣',
        component: Minesweeper,
        bestTextKey: 'arcade.mineBeginnerBest',
        bestTitle: 'Best beginner time',
        formatBest: best => formatTime(best?.durationMs),
    },
    {
        key: 'solitaire',
        title: 'Solitaire',
        textKey: 'arcade.solitaire',
        icon: '🃏',
        component: Solitaire,
        bestTextKey: 'arcade.solDrawOneBest',
        bestTitle: 'Best draw-one time',
        formatBest: best => formatTime(best?.durationMs),
    },
];

export default ARCADE_GAMES;
